import type { PollService } from "@busbud/core-types";
import type {
  RelatedPublicSegment,
  RelatedPublicSegmentV4
} from "@busbud/core-types/dist/lib/poll-service/api/udm";

const findLocation = (
  locations: Record<string, PollService.API.RelatedPublicStop>,
  id: number
): PollService.API.RelatedPublicStop | undefined => locations[id];

const findCityByLocation = (
  cities: Record<string, PollService.API.CityDetails>,
  location: PollService.API.RelatedPublicStop | undefined
) => {
  if (!location?.city_id) {
    return undefined;
  }
  const city = cities[location.city_id];
  return city;
};

export const getLegCitiesAndLocationsHelper = (
  trips_cities: Record<string, PollService.API.CityDetails>,
  trips_locations: Record<string, PollService.API.RelatedPublicStop>,
  segments: (RelatedPublicSegment | RelatedPublicSegmentV4)[]
) => {
  const first_segment = segments[0];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const origin_id = first_segment.origin_id;

  const last_segment = segments[segments.length - 1];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const destination_id = last_segment.destination_id;

  const origin_location = findLocation(trips_locations, origin_id);
  const destination_location = findLocation(trips_locations, destination_id);

  const origin_city = findCityByLocation(trips_cities, origin_location);
  const destination_city = findCityByLocation(
    trips_cities,
    destination_location
  );

  return {
    origin_city,
    destination_city,
    origin_location,
    destination_location
  };
};
